import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Money } from '../../../core/model/money';

@Component({
    selector: 'app-total-amount',
    templateUrl: './total-amount.component.html',
    styleUrls: ['./total-amount.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalAmountComponent implements OnInit {
  constructor() {}

  @Input() amount: Money;
  @Input() rounding: Money;

  get showRounding(): boolean {
    return this.rounding.amount != 0;
  }
  get roundingSign(): string {
    return this.rounding.amount > 0 ? '+' : '';
  }

  ngOnInit() {}
}
